

export const limpaTag = (tag) => tag.toString().replace(/<[^>]+>/g, '')